import { UserLayout, UserPreferences } from "./UI";

export enum MitsOrderType {
  // Normal order.
  Normal = 0,
  // Take or Kill.
  Tok = 1,
  // Fill or Kill.
  Fok = 2,
  // Iceberg.
  /* Iceberg = 4,
  // Stop order.
  Stop = 8,
  // At best.
  AtBest = 16,
  // All or nothing.
  AllOrNothing = 32,
  // At close.
  AtClose = 128, */
}
export enum Capacity {
  PrincipalCapacity = "P",
  AgencyCapacity = "A",
}
export enum State {
  Active = "A",
  Suspended = "S",
  Waiting = "W",
}
export enum BuySell {
  Buy = "B",
  Sell = "S",
}
export enum MsgType {
  OrderMan = 0,
  OrderData = 1,
  OrderDataResetRequest = 2,
  ErrorCallBack = 4,
}
export interface IMessage {
  msgType: MsgType;
}
export interface SocketResponse {
  Message: string;
  Status: "Success" | "Failed" | "Error";
}
export interface IInsertOrderFutures {
  ContractName: string;
  // buyOrSell: BuySell;
  BuyOrSell: boolean;
  DealerCode: string;
  MemeberCode: string;
  Value: number | null;
  Qty: number;
  Principal: string;
  OrderType: MitsOrderType;
  timeout_secs: number;
  PrincipalAgency: boolean;
  UserRef: string | null;
  XtraUserRef: string | null;
}
export enum InstructionType {
  Reset = 0,
  Insert = 1,
  Update = 2,
  Delete = 3,
}
interface IOrderMessage extends IMessage {
  instructionType: InstructionType;
  orderId?: number;
  time: string; // HH:mm:ss (24h format)
  member: string;
  dealer: string;
  principal: string;
  buySell: BuySell;
  state: State;
  qty: number;
  contract: string;
  price: number;
  userRef: string;
  subAccount: string;
  capacity: Capacity;
}

export interface IClientCodeDealer {
  clientCodes: string[];
  dealerCode: string;
}

export interface IClientCode {
  branch: string;
  codesPerDealer: IClientCodeDealer[];
}
export interface IMasterDealerCodes {
  branch: string;
  clientCodes: string[];
  dealers: string[];
  subAccounts: string[];
}
// export interface IFilteredDealers {
//   clients: string[];
//   dealer: string;
// }
// export interface IFilteredClients {
//   branch: string;
//   dealers: IFilteredDealers[];
// }
export interface IFilteredClients {
  dealer: string[] | null;
  clients: string[] | null;
  branch: string | null;
}
export interface IUser {
  _id: number;
  userId: string;
  uniqueCode: string;
  setup: "Dealer" | "Retail Client" | "Master Dealer";
  branch: string[];
  dealer: string[];
  client: string[];
  tradingSystem: string;
  defaultCode: string;
  username: string;
  masterdealer: boolean;
  admin: boolean;
  onScreenLimit: number;
  optionLimit: number;
  reportOnlyLimit: number;
  viewOnly: boolean;
  safexCodes: null | string[];
  filteredClients: IFilteredClients[];
  algos?: boolean | null;
  uniqueKey?: string | null;
  numberOfContracts?: null;
  limitChecking?: null;
  isIRC?: null;
  isEDM?: null;
  limit?: null;
  sanity?: null;
  traderId?: null;
  activationDate?: null;
  expiryDate?: null;
  updatedBy: string;
  createdBy: string;
  createdDate: string;
  updatedDate: string;
  fullAccess: boolean | null;
  globalDealer: string | null;
}
